var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4609 0C13.0078 0 13.5547 0.390625 13.6719 0.9375L16.5625 11.5234L17.2656 10.1562C17.6953 9.29688 18.5547 8.75 19.4922 8.75H23.75C24.4141 8.75 25 9.33594 25 10C25 10.7031 24.4141 11.25 23.75 11.25H19.4922L17.3438 15.5859C17.1094 16.0547 16.6406 16.3281 16.0938 16.25C15.5859 16.2109 15.1562 15.8594 15.0391 15.3516L12.6172 6.5625L9.96094 19.0234C9.84375 19.6094 9.33594 20 8.78906 20C8.20312 20.0391 7.69531 19.6484 7.53906 19.1016L5.27344 11.25H1.25C0.546875 11.25 0 10.7031 0 10C0 9.33594 0.546875 8.75 1.25 8.75H5.27344C6.40625 8.75 7.38281 9.49219 7.69531 10.5859L8.55469 13.5938L11.25 1.01562C11.3672 0.429688 11.875 0.0390625 12.4609 0Z",
    fill: "#D97A08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate);
export default __webpack_public_path__ + "static/media/heart-rate.c106b0207f3bb30094f87e80515da994.svg";
export { ForwardRef as ReactComponent };